//libs
import { styled } from '@nykaa/ui-components';

//global components
import OverlaySheetBase from 'shared/components/OverlaySheet';

export const OverlaySheet = styled(OverlaySheetBase)<{ hasError: boolean}>`
  background-color: ${({ theme }) => theme.colors.surface};
  height: 100%;
  width: 38%;
  max-width: 586px;
  background-color:  ${({ theme }) => theme.colors.surface};
  left: initial;
  overflow-y: auto;
  overflow-x: hidden;
  ${({ hasError }) => hasError &&`
    overflow-y: hidden;
  `}
`;

export const ErrorState = styled.div`
  display: flex;
  align-items: center;
  height: 70vh;
  padding: 0 ${({ theme }) => theme.spacing.spacing160} 0;
`;
